import { render, staticRenderFns } from "./higherSecondary.vue?vue&type=template&id=5c557847&"
import script from "./higherSecondary.vue?vue&type=script&lang=js&"
export * from "./higherSecondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports